export const sqmToSqFtRounded = (meters) => {
  return Math.round(meters * 10.7639104167);
};
